import { Link } from '@/components/Link';
import OLWBannerDesktop from '@/hant/public/image/OLW-banner-desktop.jpg';
import OLWBannerMobile from '@/hant/public/image/OLW-banner-mobile.jpg';
import { useAppState } from '@/hooks/useAppState';
import NextImage from 'next/image';

const OLWBanner = () => {
  const [{ publishedUrl, isFrontPage, isArticlePage, category }] = useAppState();

  const isMainFrontPage = isFrontPage && publishedUrl === '/index';
  const isMelodifestivalenFrontPage = isFrontPage && publishedUrl === '/melodifestivalen';
  const isMelodifestivalenArticlePage = isArticlePage && category === 'melodifestivalen';

  if (![isMainFrontPage, isMelodifestivalenFrontPage, isMelodifestivalenArticlePage].some(Boolean)) {
    return null;
  }

  return (
    <section className="relative mb-4">
      {!isMelodifestivalenFrontPage && <Link href="/melodifestivalen" options={{ cover: true }} />}
      <picture>
        <NextImage className="hidden sm:block" alt="OLW melodifestivalen" src={OLWBannerDesktop} />
        <NextImage className="block sm:hidden" alt="OLW melodifestivalen" src={OLWBannerMobile} />
      </picture>
    </section>
  );
};

export default OLWBanner;
